<script>
    import { getEntity } from "../../../../api-client";
    import LoadingSquare from "../../../../common/LoadingSquare.svelte";
    import AudioPage from "./AudioPage.svelte";
    import { _ } from 'svelte-i18n'

    export let showHeader = true;
    export let params = {};

    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    $: podcastId = params.id;
    $: episodeId = params.trackId;

    $: episode = getEntity("podcast_episode", episodeId).then(
        async (episode) => {
            if (episode) {
                const info = await getEntity(
                    "podcast_info",
                    episode.fk_podcast_info
                );
                episode.info = { ...info, type: "podcast" };
                console.log(episode);
                return episode;
            }
        }
    );
</script>

{#await episode}
    <LoadingSquare />
{:then episode}
    <AudioPage
        showNext={false}
        showBack={false}
        image={episode.image}
        audio={episode.src}
        audioTitle={episode.title}
        audioInfo={episode.info}
        {podcastId}
        {showHeader}
    />
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}
